import "./style.scss";
import * as React from "react";
import { withRouter } from "react-router-dom";

import ReportForm from "../ReportForm";

class EditReport extends React.Component<any, any> {
  componentWillMount() {
    let { merchant_id, report_id } = this.props.match.params;
    this.props.flushReport();
    this.props.getReport(merchant_id, report_id);
    this.props.getSchema();
  }

  handleSubmit(merchant_id: number, form: any, sendAfter: boolean) {
    this.props.editForm(
      this.props.match.params.merchant_id,
      this.props.match.params.report_id,
      form,
      sendAfter
    );
  }

  render() {
    return (
      <div className="edit-report">
        <ReportForm
          type="Edit"
          submit={this.handleSubmit.bind(this)}
          {...this.props}
        />
      </div>
    );
  }
}

export default withRouter(EditReport);



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/EditReport/component.tsx